import React from "react"
import Services from "../components/Services/Services"
import { ServicesContextProvider } from "../components/Services/ServicesContext";

const ServicesContaner = () => {
  return (
    <div>
      <ServicesContextProvider>
        <Services />
      </ServicesContextProvider>
    </div>
  )
}

export default ServicesContaner
